export default __webpack_public_path__ + "static/media/paper-clip.96a7d4d1.svg";